import { render, staticRenderFns } from "./allComment.vue?vue&type=template&id=c51a3166&scoped=true"
import script from "./allComment.vue?vue&type=script&lang=js"
export * from "./allComment.vue?vue&type=script&lang=js"
import style0 from "./allComment.vue?vue&type=style&index=0&id=c51a3166&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c51a3166",
  null
  
)

export default component.exports